<div class="menu-bg" *ngIf="menuOpen" [@menuBg] (click)="close(undefined)"></div>
<div class="menu-item size-{{options.size}}" *ngIf="menuOpen" [@menuContent]>
  <div class="menu-content section spacing-x-{{options.spacingX}} spacing-y-{{options.spacingY}}"
    [class.dark]="options.style === 'dark'">
    <button (click)="close(undefined)" color="simple" appButton name="close" location="mobile-menus" shape="round"
      [iconButton]="true" class="close-button">
      <app-svg src="/assets/icons/cross.svg"></app-svg>
    </button>
    <ng-template #placeholder></ng-template>
  </div>
</div>
